"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = require("react");
var React = require("react");
var react_router_dom_1 = require("react-router-dom");
var auth_1 = require("../auth");
var FloatingLabelInput_1 = require("./FloatingLabelInput");
var react_intl_1 = require("react-intl");
var CommonHeader_1 = require("./CommonHeader");
var ReactPasswordStrength_1 = require("./ReactPasswordStrength");
var ChangePasswordStyle_1 = require("./ChangePasswordStyle");
var App_1 = require("./App");
var ErrorMessageComponent_1 = require("./ErrorMessageComponent");
var ChangePassword = function (props) {
    var context = react_1.useContext(App_1.LanguageContext);
    var _a = react_1.useState(props.userName), preferred_username = _a[0], setPreferredUsername = _a[1];
    var _b = react_1.useState(''), oldPassword = _b[0], setOldPassword = _b[1];
    var _c = react_1.useState(''), newPassword = _c[0], setNewPassword = _c[1];
    var _d = react_1.useState(''), confirmPassword = _d[0], setConfirmPassword = _d[1];
    var _e = react_1.useState(false), inlineErrorOldPassword = _e[0], setInlineOldPassword = _e[1];
    var _f = react_1.useState(false), inlineErrorNewPassword = _f[0], setInlineErrorNewPassword = _f[1];
    var _g = react_1.useState(false), inlineErrorConfirmPassword = _g[0], setInlineErrorConfirmPassword = _g[1];
    var _h = react_1.useState(false), pass = _h[0], setPass = _h[1];
    var _j = react_1.useState(false), showMessage = _j[0], setShowMessage = _j[1];
    var _k = react_1.useState(''), message = _k[0], setMessage = _k[1];
    var _l = react_1.useState(false), loading = _l[0], setLoading = _l[1];
    var updatePassword = function () { return __awaiter(void 0, void 0, void 0, function () {
        var err_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (oldPassword === '') {
                        setInlineOldPassword(true);
                        setPass(false);
                        setShowMessage(false);
                        setMessage('');
                        setLoading(false);
                    }
                    if (newPassword === '') {
                        setInlineErrorNewPassword(true);
                        setPass(false);
                        setShowMessage(false);
                        setMessage('');
                        setLoading(false);
                    }
                    if (confirmPassword === '') {
                        setInlineErrorConfirmPassword(true);
                        setPass(false);
                        setShowMessage(false);
                        setMessage('');
                        setLoading(false);
                    }
                    if (oldPassword == newPassword) {
                        setPass(false);
                        setShowMessage(true);
                        setMessage('Old Password and New Password Should not be same');
                        setLoading(false);
                    }
                    if (!(oldPassword !== '' &&
                        newPassword !== '' && oldPassword !== newPassword)) return [3 /*break*/, 4];
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, , 4]);
                    setLoading(true);
                    return [4 /*yield*/, auth_1.InfoAuth.changePassword(preferred_username, oldPassword, newPassword)];
                case 2:
                    _a.sent();
                    props.history.push('/login');
                    return [3 /*break*/, 4];
                case 3:
                    err_1 = _a.sent();
                    setLoading(false);
                    if (err_1.message != null) {
                        setPass(false);
                        setShowMessage(true);
                        setMessage(err_1.message);
                    }
                    return [3 /*break*/, 4];
                case 4: return [2 /*return*/];
            }
        });
    }); };
    return (React.createElement("div", null,
        React.createElement(CommonHeader_1.default, __assign({ setLanguage: context.setLanguage }, props)),
        React.createElement(ChangePasswordStyle_1.ChangePasswordStartMsgOuterContainer, null,
            React.createElement(ChangePasswordStyle_1.ChangePasswordMsgContainer, null,
                React.createElement(react_intl_1.FormattedMessage, { id: 'changePassword.changePasswordStart' }))),
        React.createElement(ChangePasswordStyle_1.ParentWrapperContainer, null,
            React.createElement(ChangePasswordStyle_1.ChangePasswordContainer, null,
                React.createElement(ChangePasswordStyle_1.WrapperContainer, null,
                    React.createElement(ChangePasswordStyle_1.Form, null,
                        React.createElement(ChangePasswordStyle_1.ChangePassTitleSpanContainer, { showMessage: showMessage },
                            React.createElement("strong", null,
                                React.createElement(react_intl_1.FormattedMessage, { id: "changePassword.title" }))),
                        React.createElement(ErrorMessageComponent_1.default, { pass: pass, showMessage: showMessage, message: message }),
                        React.createElement(FloatingLabelInput_1.FloatingLabelInput, { id: "oldPassword", dispalyLabel: React.createElement(react_intl_1.FormattedMessage, { id: "changePassword.oldPassword" }), onChange: setOldPassword, value: oldPassword, inlineError: inlineErrorOldPassword, setInLineError: setInlineOldPassword, type: "password", inlineMsg: React.createElement(react_intl_1.FormattedMessage, { id: "changePassword.inlineMsgOldPwd" }) }),
                        React.createElement(ReactPasswordStrength_1.default, { locale: props.locale, intl: props.intl, id: "newPassword", dispalyLabel: React.createElement(react_intl_1.FormattedMessage, { id: "changePassword.newPassword" }), onChange: setNewPassword, value: newPassword, inlineError: inlineErrorNewPassword, setInLineError: setInlineErrorNewPassword, type: "password", inlineMsg: React.createElement(react_intl_1.FormattedMessage, { id: "changePassword.inlineMsgNewPwd" }) }),
                        React.createElement(ChangePasswordStyle_1.CustomButton, { size: "lg", loading: loading, onClick: updatePassword },
                            ' ',
                            React.createElement(react_intl_1.FormattedMessage, { id: "changePassword.btnChangePassword" }),
                            ' ')))))));
};
exports.default = react_intl_1.injectIntl(react_router_dom_1.withRouter(ChangePassword));
//# sourceMappingURL=ChangePassword.js.map